module.exports = __webpack_public_path__ + "static/media/PLI_Logo.8d252dc4.svg";